import { render } from "./Cardapio.vue?vue&type=template&id=70b7e823&scoped=true"
import script from "./Cardapio.vue?vue&type=script&lang=js"
export * from "./Cardapio.vue?vue&type=script&lang=js"

import "./Cardapio.vue?vue&type=style&index=0&id=70b7e823&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\natan\\OneDrive\\Code\\Site\\dalena\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b7e823"]])

export default __exports__